import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import { BootstrapIcon } from "../BootstrapIcon"

import { agreement } from './agreement.js';

import { useAuth } from '../../auth';
import * as choiceApi from '../../api/choice';

import './agreement.css';

export function PrivacyAgreement() {

    const { user, signin, signout } = useAuth();

    //
    // If no one is logged in, then they don't have a privacy agreement
    //
    if (!user) {
        return null;
    }

    //
    // If we have a user, we need to know if they signed after the last change
    //
    const { agreementSigned, agreementChanged } = user;
    const agreementValid = new Date(agreementSigned) > new Date(agreementChanged);

    async function onDecline() {
        signout();
    }

    async function onAccept() {
        try {
            const newUser = await choiceApi.signPrivacyAgreement(new Date().toISOString().split('T')[0]);
            signin(newUser)
        }
        catch (err) {
            signout();
        }
    }

    return (
        <Modal show={!agreementValid} onHide={onDecline}>
            <Modal.Header closeButton closeVariant='white'>
                <Modal.Title>Privacy Agreement Acknowledgement</Modal.Title>
            </Modal.Header>
            <Modal.Body className="agreement-dialog">
                {agreement}
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-between w-100">
                    <div>
                        <a href={process.env.PUBLIC_URL + '/pdf/agreement.pdf'}>
                            <Button variant="outline-secondary">
                                <BootstrapIcon icon="file-pdf" /> Print
                            </Button>
                        </a>
                    </div>
                    <div>
                        <Button variant="outline-secondary" onClick={onDecline}>
                            Decline
                        </Button>
                        <Button className="ms-2" variant="primary" onClick={onAccept}>
                            Accept
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
